// extracted by mini-css-extract-plugin
export default {"formHeading":"RI-z","form":"SI-z","submitBtn":"TI-z","disabled":"UI-z","input":"VI-z","error":"WI-z","submitMsg":"XI-z","signIn":"YI-z"};